module.exports = __webpack_public_path__ + "static/media/npr-logo.2026c3c6.jpg";